import React from 'react'
import { Dialog, makeStyles } from '@material-ui/core'
import { useDeviceCode } from '../../util/device-code'
import GlueButton from '../glueos-components/glue-button'

const useStyles = makeStyles(theme => ({
  root: {
    width: '640px',
    height: '520px',
    display: 'flex',
    flexFlow: 'column',
    overflow: 'hidden',
    gap: theme.spacing('xl'),
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${theme.spacing('xl')}`
  },

  title: {
    height: '64px',
    display: 'flex',
    alignItems: 'center'
  },

  deviceCode: {
    fontSize: '64px',
    fontWeight: 600,
    lineHeight: '64px',
    color: theme.palette.alert.main
  },

  textArea: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },

  alertText: {
    color: theme.palette.alert.main
  }
}), { name: 'MuiGlueLoginCodeDialog' })

const LoginCodeDialog = (props) => {
  const classes = useStyles()
  const { deviceCode, idToken } = useDeviceCode(props)

  if (idToken) {
    props.onCloseDialog(idToken)
  }

  return (
    <Dialog
      open={!!props.open}
      maxWidth={false}
    >
      <div className={classes.root}>
        <div className={classes.title}>
          <h2>Glue Device Code</h2>
        </div>
        <h1 className={classes.deviceCode}>{deviceCode}</h1>
        <div className={classes.textArea}>
          <p>Enter the above code in</p>
          <p className={classes.alertText}>https://glue.work/code</p>
          <br />
          <p>Log in with your Glue account, using any web browser.<br />This dialog will close when login is complete.</p>
        </div>
        <GlueButton width='168px' onPointerDown={() => props.onCloseDialog(null)}>Cancel</GlueButton>
      </div>
    </Dialog>
  )
}

export default LoginCodeDialog
